import { Button } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { isAndroid, isIOS } from 'utils/detechMobileDevice';
import Money from 'components/Money/Money';
import media from 'utils/mediaStyle';
import utilsMessages from 'utils/messages';

const FooterWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #ffffff !important;

  ${media.lg`
    display: none;
  `}
`;

const ConfirmWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-top: 8px;
  padding: 8px 16px;
`;

const TotalCartItem = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const TotalCartItemValue = styled.div`
  font-size: 16px;
  line-height: 24px;
  color: #3c9041;
  font-weight: 700;
  letter-spacing: -0.32px;
`;

const TotalPayableTitle = styled.div`
  font-size: 12px;
  line-height: 18px;
  color: #111827;
  font-weight: 500;
`;

const NextButton = styled(Button)`
  width: 176px;
  height: 44px;
  font-weight: 500 !important;
  font-size: 16px !important;
  box-shadow: none !important;
  border-radius: 8px !important;
  border: none !important;
  background: #43a047 !important;
  color: #ffffff !important;
`;

const VoucherOnMobile = styled.div`
  background: #ebffd2;
  font-size: 12px;
  color: #111827;
  font-weight: 500;
  padding: 8px 12px;
  text-align: center;
`;

interface CartFooterProps {
  deliveryFee: any;
  subTotal: number;
  cartMoq: number;
  currentStep: number;
  netTotalOrder: number;
  totalDiscount: number;
  loading: boolean;
  orderDisabled: boolean;
  onGoNext: () => void;
}

const CartFooter = (props: CartFooterProps) => {
  const {
    deliveryFee,
    subTotal,
    cartMoq,
    currentStep,
    netTotalOrder,
    totalDiscount,
    loading,
    orderDisabled,
    onGoNext,
  } = props;

  return (
    <FooterWrapper>
      <VoucherOnMobile
        onClick={() => {
          if (isIOS()) {
            window.location.href = 'https://apps.apple.com/sa/app/kamereo/id1469505654';
          } else if (isAndroid()) {
            window.location.href =
              'https://play.google.com/store/apps/details?id=vn.kamereo.buyer&amp;hl=en_US&amp;gl=US';
          }
        }}
      >
        <FormattedMessage {...utilsMessages.voucherMobile} />
      </VoucherOnMobile>
      <ConfirmWrapper>
        <TotalCartItem>
          <TotalPayableTitle>
            <FormattedMessage {...utilsMessages.totalPayable} />
          </TotalPayableTitle>

          <TotalCartItemValue>
            <Money>{netTotalOrder}</Money>
          </TotalCartItemValue>
        </TotalCartItem>
        <NextButton disabled={orderDisabled} loading={loading} onClick={onGoNext} type="primary">
          {currentStep === 1 ? (
            <FormattedMessage {...utilsMessages.placeYourOrder} />
          ) : (
            <FormattedMessage {...utilsMessages.makeOrder} />
          )}
        </NextButton>
      </ConfirmWrapper>
    </FooterWrapper>
  );
};

export default CartFooter;
